import { View } from '@play-co/timestep-core/ui';
import StreakCloudRow from './StreakCloudRow';

export default class StreakCloudShade extends View {
  private background: View;
  private cloudBack: StreakCloudRow;
  private cloudFront: StreakCloudRow;

  public get ratio() {
    return this.background.style.height / this.style.height;
  }

  public set ratio(v: number) {
    this.background.style.height = this.style.height * v;
    this.background.style.offsetY =
      this.style.height - this.background.style.height;
    this.cloudBack.style.offsetY = this.background.style.offsetY * 0.92;
    this.cloudFront.style.offsetY = this.background.style.offsetY;
  }

  constructor(opts: { superview: View; width: number; height: number }) {
    super({ ...opts, clip: true });

    this.background = new View({
      ...opts,
      backgroundColor: '#FFFFFF',
    });

    this.cloudBack = new StreakCloudRow({
      superview: this,
      width: opts.width,
      variant: 'cloud2',
      gap: -1,
      speed: 0.8,
      opacity: 0.6,
    });

    this.cloudFront = new StreakCloudRow({
      superview: this,
      width: opts.width,
      variant: 'cloud3',
      gap: -1,
      speed: 2,
    });
  }
}
